<template>
  <div>
    <Modal
      v-model="updatesome"
      footer-hide
      title="批量修改库存及货架状态"
      width="500px"
    >
      <a
        href="https://img.g-part.cn/test/oms/2022/03/09/16468201649597415.xls"
        class="abq"
        >下载模板</a
      >
      <!-- 表单 -->
      <Form
        ref="formValidate"
        :label-width="100"
        :model="formValidate"
        class="from"
        :rules="ruleValidate"
      >
        <FormItem label="上传文件:" prop="Browse" class="Browse1">
          <div class="Browse">
            <Input
              v-model="formValidate.Browse"
              style="width:300px;height:32px"
            ></Input>
            <Upload
              :show-upload-list="false"
              action=""
              :on-success="uploading"
              :before-upload="handleUpload"
            >
              <Button  type="primary" style="width:60px;margin-left:20px">浏览</Button>
            </Upload>
          </div>
        </FormItem>
      </Form>
      <div v-if="isshowgx" style="margin-left:20px;margin-top:20px">
        <p class="fz14"><b>批量更新结果:</b></p>
        <p class="fz14">
          总计<span>{{ total1 }}</span
          >行
        </p>
        <p class="fz14">
          更新成功<span>{{ succeed }}</span
          >行
        </p>
        <p class="fz14">
          更新失败<span>{{ loser }}</span
          >行
          <a class="a2" :href="loseinventory">(请导出更新失败商品清单)</a>
        </p>
      </div>
      <div class="updatebtn">
        <Button
          style="background-color:#377CF1;color:#fff;border:none;margin-right:20px"
          :loading="loading"
          @click="Update('formValidate')"
          >确定</Button
        >
        <Button @click="close('formValidate')" style="margin-left:20px">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
// import urlObj from '@/config/env.js' // 环境
import { batchamend } from '@/api/myweb/goods/components/goodsBatch'
// import Cookies from 'js-cookie' // Cookies的来源
// import { TOKEN_KEY } from '@/libs/util' // TOKEN_KEY的值
export default {
  data() {
    return {
      // token: Cookies.get(TOKEN_KEY), //拿到token
      // uploadFile: urlObj.wss, // 走的环境
      updatesome: false, // 关闭批量更新库存
      isshowgx: false, // 显示更新
      formValidate: {
        Browse: ''
      }, // 表单
      ruleValidate: {
        Browse: [
          {
            required: true,
            message: '请上传文件',
            trigger: 'change'
          }
        ]
      }, // 表单规则
      file: null, // 文件流
      total1: null, // 总的上传
      succeed: null, // 成功的上传
      loser: null, // 失败的上传
      loseinventory: '', // 失败之后的地址的
      loading: false //转圈
    }
  },

  methods: {
    // 关闭
    close() {
      this.updatesome = false
      this.isshowgx = false
    },
    // 开启
    openupdate() {
      this.$refs.formValidate.resetFields()
      this.updatesome = true
      this.isshowgx = false
    },
    // 批量更新  batchappend
    Update(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          this.loading = true
          let gx = new FormData()
          console.log(gx)
          gx.append('file', this.file)
          const res = await batchamend(gx)
          console.log(res)
          if (res.status) {
            this.loading = false
            this.isshowgx = true
            this.total1 = res.data.total
            this.succeed = res.data.succeed
            this.loser = res.data.loser
            this.loseinventory = res.data.filePath
            this.$Message.destroy()
            this.$Message.success(res.message)
            this.$emit('refush')
          } else {
            this.loading = false
          }
        }
      })
    },
    // 文件上传成功时的钩子
    uploading(file) {
      if (file.code == 0) {
        this.$Message.success(file.message)
      } else {
        this.$Message.error(file.message)
      }
    },
    // 上传文件之前的钩子
    handleUpload(file) {
      console.log(file)
      this.formValidate.Browse = file.name
      this.file = file
      return false
    }
  }
}
</script>

<style lang="less" scoped>
.from {
  margin-top: 20px;
  // border: 1px solid;
}

/deep/.ivu-form-item {
  margin: 0;
}
.Browse {
  display: flex;
}
.updatebtn {
  margin-top: 20px;
  text-align: center;
}
.a1 {
  color: #fff;
}
.a2 {
  color: #0074ff;
}
.abq {
  color: #0074ff;
  display: inline-block;
  margin-left: 18px;
}
.app{
  /deep/.ivu-form-item{
    margin-bottom: 10px !important;
  }
}
/deep/ .ivu-form-item-label{
  text-align: center;
}
</style>
